/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Created by randysorensen on 8/2/16.
 */
'use strict';
angular
	.module('prism-ui.workflows')
	.controller('WorkflowStepViewController',
	function (
        _,
        $interval,
        $q,
        $routeParams,
	    $scope,
        $timeout,
        parentWorkflow,
        BreadcrumbService,
        NavbarUtilService,
        PaginationService,
        PermissionsService,
        SearchFilterService,
        WorkflowExecutionResourceFactory
    ) {
		var self = this;

		var WORKFLOW_VIEW_STATE = 'DASHBOARD_WORKFLOW_VIEW';

		BreadcrumbService.editService = {
			editorForm: {
				$pristine: true
			}
		};

		self.parentWorkflowId = $routeParams.id;
		self.parentWorkflowExecutionLabel = parentWorkflow.executionLabel;
		self.selectedStep = null;

		self.pagingOptions = PaginationService;

		self.pollingInterval = null;
		self.perms = {
			read: false,
			write: false
		};

		self.gridApi = null;

		self.loadingIndicator = {
			backdrop: true,
			show: false,
			title: 'Working',
			message: 'Please wait...'
		};

		self.gridColumnDefs = [
			{
				field: 'percentComplete',
				width: '200',
				displayName: 'Status',
				enableSorting: true,
				enableColumnResizing: true,
				cellTemplate: 'components/visual/grid/progress-bar-template.html'
			},
			{
				field: 'executionLabel',
				displayName: 'Type',
				enableSorting: true,
				enableColumnResizing: true,
				cellTemplate: 'components/visual/grid/base-tooltip-template.html'
			},
			{
				field: 'startDate',
				width: '200',
				displayName: 'Start',
				enableSorting: true,
				enableColumnResizing: true,
				cellFilter: 'amDateFormat:"MMM, D, YYYY, h:mm:ss A"',
				sort: {
					direction: 'desc',
					priority: 0
				}
			},
			{
				field: 'endDate',
				width: '200',
				displayName: 'End',
				enableSorting: true,
				enableColumnResizing: true,
				cellFilter: 'amDateFormat:"MMM, D, YYYY, h:mm:ss A"'
			}
		];
		self.gridOptions = {
			rowSelection: true,
			enableRowHeaderSelection: false,
			enableSelectAll: false,
			enableSorting: true,
			enableColumnMenus: false,
			enableFullRowSelection: true,
			rowHeight: 30,
			multiSelect: false,
			columnDefs: self.gridColumnDefs,
			onRegisterApi: function(gridApi) {
			 	self.gridApi = gridApi;
			 	self.gridApi.selection.on.rowSelectionChanged(
			 		$scope, self.gridRowSelectionChangedHandler
				);
			},
			rowTemplate: '<div ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" ' +
							  'class="ui-grid-cell" ui-grid-cell> ' +
						 '</div>',
			data: []
		};

		self.gridRowSelectionChangedHandler = function(row) {
			if (!row.isSelected) {
				self.selectedStep = null;
			} else {
				self.selectedStep = row.entity;
			}
		};

		self.detailViewCloseHandler = function () {
			self.selectedStep = null;
			self.gridApi.selection.clearSelectedRows();
		};

		var updateRow = function(oldStep, newStep) {
            _.forEach(oldStep, function(value, key) {
                if (!_.isEqual(value, newStep[key])) {
                    oldStep[key] = newStep[key];
                }
            });
        };

		var updateGrid = function(newStepData) {
			var newStepDict = {};

			angular.forEach(newStepData, function(step) {
				newStepDict[step.id] = step;
			});

			for (var k = 0; k < self.gridOptions.data.length; k++) {
				var oldStep = self.gridOptions.data[k];
				if (oldStep.id in newStepDict) {
				    // Keep oldStep object so selectedStep still points to correct data
                    updateRow(oldStep, newStepDict[oldStep.id]);
					delete newStepDict[oldStep.id];
				} else {
					self.gridOptions.data.splice(k, 1);
				}
			}

			angular.forEach(newStepDict, function(step) {
				self.gridOptions.data.push(step);
			});
		};

		var getStepData = function() {
			if (!self.perms.read) {
				self.gridOptions.data = [];
				return;
			}

			if (!self.pollingInterval) {
				$scope.$broadcast('server-busy', {working: true});
				self.pollingInterval = $interval(getStepData, 10000);
			}
			var queryOpts = {
				id: self.parentWorkflowId,
				fetchOffset: 0,
				fetchLimit: -1
			};

			WorkflowExecutionResourceFactory.getExecutionSteps(
				queryOpts,
				function (stepArray) {
					updateGrid(stepArray);
					$scope.$broadcast('server-busy', {working: false});
				}
			);
		};

		var getPermissions = function () {
			$scope.$broadcast('server-busy', {working: true});
			var canRead = PermissionsService.canRead(WORKFLOW_VIEW_STATE);
			var canWrite = PermissionsService.canWrite(WORKFLOW_VIEW_STATE);
			$q.all({
				read: canRead,
				write: canWrite
			}).then(function (perms) {
				self.perms = perms;
				getStepData();
			});
		};

		//
		// 2017-July-18 (RS)
		//
		// Pagination isn't enabled for workflow steps, and this
		// code isn't yet covered by unit tests, so I'm removing
		// it.
		//

		// self.paginationPrevPageHandler = function () {
		// 	--self.pagingOptions.currentPage;
		// 	self.onPaginationChanged();
		// };
        //
		// self.paginationNextPageHandler = function () {
		// 	++self.pagingOptions.currentPage;
		// 	self.onPaginationChanged();
		// };
        //
		// self.paginationJumpToPageHandler = function () {
		// 	self.onPaginationChanged();
		// };
        //
		// self.onPaginationChanged = function () {
		// 	getStepData();
		// };

        SearchFilterService.populateCriteriaFromLocationSearch();
		NavbarUtilService.viewSearchFunction = function () {
			$scope.$broadcast('server-busy', {working: true});
			getStepData();
		};

		// $scope.$watch(function() {
		// 		return self.pagingOptions.pageSize;
		// 	},
		// 	function (newValue, oldValue) {
		// 		if (newValue !== oldValue) {
		// 			self.currentPageSize = newValue;
		// 			self.onPaginationChanged();
		// 		}
		// 	}
		// );

		$scope.$on('server-busy', function (event, options) {
			self.loadingIndicator.show = options.working;
		});

		$scope.$on('$destroy', function() {
			NavbarUtilService.viewSearchFunction = null;
			$interval.cancel(self.pollingInterval);
		});

		getPermissions();
	}
);
